import { defineComponent as _defineComponent } from 'vue'
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import BCXDottedCollapsible from '@/components/molecules/BCXDottedCollapsible.vue';
import { useVModel } from '@vueuse/core';
import { computed } from 'vue';
import useResponsiveness from '@/mixins/useResponsiveness';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXInfoCollapsible',
  props: {
  text: {
    type: String,
    default: ''
  },
  isOpened: Boolean,
  addTopPadding: {
    type: String,
    default: '0'
  },
  addBottomPadding: {
    type: String,
    default: '0'
  },
  forcedHeight: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props;



const { isDesktopWidth } = useResponsiveness();
const isOpenedVM = useVModel(props, 'isOpened');
const markdownStyle = computed(() => (props.forcedHeight && isDesktopWidth.value ? { height: props.forcedHeight } : null));


return { __sfc: true,props, isDesktopWidth, isOpenedVM, markdownStyle, BCXMarkdown, BCXDottedCollapsible }
}

})